// top, left "=> left"%", bot%"tom

export const PLAYER_POSITION: any = {
    1: { top: "92.0%", left: "50.0%" }, // thu mon
    2: { top: "92.0%", left: "50.0%" }, // hau ve
    5: { top: "8.0%", left: "50.0%" }, 
    6: { top: "72.0%", left: "50.0%" },
    7: { top: "73.5%", left: "14.5%" }, // hau ve trai
    8: { top: "73.5%", left: "84.5%" },
    9: { top: "60.0%", left: "14.5%" },
    10: { top: "22.0%", left: "14.5%" },
    11: { top: "60.0%", left: "84.5%" },
    12: { top: "22.0%", left: "84.5%" },
    13: { top: "47.0%", left: "50.0%" },
    14: { top: "59.0%", left: "50.0%" },
    15: { top: "32.0%", left: "50.0%" },
    16: { top: "28.0%", left: "50.0%" },
    17: { top: "56.0%", left: "50.0%" },
    18: { top: "42.0%", left: "14.5%" },
    19: { top: "42.0%", left: "84.5%" },
    20: { top: "32.0%", left: "14.5%" },
    21: { top: "32.0%", left: "84.5%" },
    22: { top: "12.0%", left: "14.5%" },
    23: { top: "12.0%", left: "84.5%" },
    24: { top: "18.0%", left: "50.0%" },
};